import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <FooterContainer>
        <Social>
          <h3 data-aos="zoom-in-up">
            <a
              href="https://www.linkedin.com/in/damian-aluku-59b06023a"
              target="_blank "
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </h3>
          <h3 data-aos="zoom-in-up">
            <a
              href="Mailto:damaluku@gmail.com"
              target="_blank "
              rel="noreferrer"
            >
              mail
            </a>
          </h3>
        </Social>

        <Credits>
          <h4>
            Developed by
            <a
              href="https://www.linkedin.com/in/damian-aluku-59b06023a"
              // href="https://zety.com/profile/damian-aluku"
              target="_blank"
              rel="noreferrer"
            >
              Damian aluku
            </a>
          </h4>
        </Credits>
      </FooterContainer>
    </>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  max-width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin: 2rem 0 8rem 0;

  @media screen and (max-width: 760px) {
    min-height: 30vh;
    margin-bottom: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
`;

const Social = styled.div`
  display: flex;

  h3 {
    text-transform: capitalize;
    margin-right: 1rem;
    font-size: 1.5rem;

    a {
      text-decoration: none;
      color: ${(props) => props.theme.dark.custom};
    }
  }

  @media screen and (max-width: 760px) {
    justify-content: space-around;

    h3 {
      font-size: 1rem;
      margin-right: 0;
    }
  }
`;

const Credits = styled.div`
  display: flex;
  justify-content: center;
  z-index: 1;

  h4 {
    text-transform: capitalize;

    a {
      color: ${(props) => props.theme.dark.custom};
      text-decoration: none;
      padding-left: 5px;
    }
  }
`;
